export function Notification() {
  return {
    _validTypes: {
      progress: "info",
      info: "secondary",
      warning: "warning",
      error: "danger",
      success: "success",
    },

    icons: {
      info: "bi-info-circle",
      warning: "bi-exclamation-triangle", // corrected name
      error: "bi-x-circle",
      success: "bi-check-square",
      progress: "bi-hourglass-split", // optional, uncomment if needed
    },
    visible: false,
    type: "info",
    title: "",
    time: "",
    message: "",
    _defaultVisibleDuration: 2000,

    showNotification(title, message, type = "info", showFor = null) {
      if (!Object.keys(this._validTypes).includes(type)) {
        type = "info";
      }

      this.visible=false;

      this.type = type;
      this.message = message;
      this.title = title;

      this.visible = true;

      if (showFor >= 0 || (showFor === null && this.type !== "progress")) {
        // Use an arrow function here (=>)
        setTimeout(() => {
          this.visible = false;
        }, showFor * 1000 ?? this._defaultVisibleDuration);
      }
    },

    hide() {
      this.visible = false;
    },
  };
}
